export default {"src":"/_next/static/media/SG.5c1a5c72.svg","height":34,"width":50,"blurWidth":0,"blurHeight":0};